import {Icon} from '@/components/atoms'
import React from 'react'

const WarningLabel = ({title}) => {
  return (
    <div className="mt-6 flex flex-row items-center">
      <Icon alt="" icon="warning" size="small" className="text-yellow-400" />
      <p className="text ml-1 text-sm text-white">{title}</p>
    </div>
  )
}

export default WarningLabel
